
export const setApi = (data) => {
return {
  type: "SET_API_DATA",
  payload: data,
};
}




export const setBrands = (product) => {
  return {
    type: "SET_BRANDS",
    payload: product,
  };
};

export const AddItem = (item) => {
  return {
    type: "ADD_ITEM",
    payload: item,
  };
};


export const deleteItem = (id) => {
  return {
    type: "DELETE_ITEM",
    payload: id,
  };
};

export const increaseItem = () => {
  return {
    type: "INCREASE_ITEM",
  };
};

export const decreaseItem = () => {
  return {
    type: "DECREASE_ITEM",
  };
};

export const increaseNotification = () => {
  return {
    type: "INCREASE_NOTIFICATION",
  };
};

export const decreasNotification = () => {
  return {
    type: "DECREASE_NOTIFICATION",
  };
};

